import React from "react";
import "./HeaderNav.css";
import { Navbar, Nav } from "react-bootstrap";
import { Link } from "react-scroll";

function HeaderNav() {
  return (
    <div className='navbar__design'>
      <Navbar expand='lg'>
        <Link
          className='navbar-brand'
          to='home-id'
          spy={true}
          smooth={true}
          duration={500}
        >
          <span
            style={{ color: "#f7fff7", fontSize: "20px", cursor: "pointer" }}
          >
            Azizul Haque
          </span>
        </Link>
        <Navbar.Toggle aria-controls='basic-navbar-nav' />
        <Navbar.Collapse id='basic-navbar-nav'>
          <Nav className='ml-auto'>
            <Nav.Link>
              {/* <NavLink
                className='text-white'
                style={{ fontWeight: "700" }}
                to='/home'
              > */}
              <Link
                className='text-white'
                to='home-id'
                spy={true}
                smooth={true}
                duration={500}
              >
                Home
              </Link>
              {/* </NavLink> */}
            </Nav.Link>
            <Nav.Link>
              {/* <NavLink
                className='text-white'
                style={{ fontWeight: "700" }}
                to='/projects'
                // href="#projects-id"
              > */}
              <Link
                className='text-white'
                to='projects-id'
                spy={true}
                smooth={true}
                duration={500}
              >
                Projects
              </Link>
              {/* </NavLink> */}
            </Nav.Link>
            <Nav.Link>
              {/* <NavLink
                className='text-white'
                style={{ fontWeight: "700" }}
                to='/skills'
              > */}
              <Link
                className='text-white'
                to='skills'
                spy={true}
                smooth={true}
                duration={500}
              >
                Skills
              </Link>
              {/* </NavLink> */}
            </Nav.Link>
            <Nav.Link>
              {/* <NavLink
                className='text-white'
                style={{ fontWeight: "700" }}
                to='/blogs'
              > */}
              <Link
                className='text-white'
                to='blogs-id'
                spy={true}
                smooth={true}
                duration={500}
              >
                Blogs
              </Link>
              {/* </NavLink> */}
            </Nav.Link>
            <Nav.Link>
              {/* <NavLink
                className='text-white'
                style={{ fontWeight: "700" }}
                to='/about'
              > */}
              <Link
                className='text-white'
                to='footer-id'
                spy={true}
                smooth={true}
                duration={500}
              >
                About
              </Link>
              {/* </NavLink> */}
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
}

export default HeaderNav;
